import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  RentPaymentFailureFeeSettings,
  RentPaymentFailureFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const BASE_URL = `${SETTINGS_BASE_URL}/rentpaymentfailurefee`;

export class rentPaymentFailureFeeSettingsRepository extends BaseRestRepository {
  public getRentPaymentFailureFeeSettings = async (): Promise<RentPaymentFailureFeeSettings> => {
    const url = `${BASE_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  };

  public deleteRentPaymentFailureFeeSettings = async (): Promise<void> => undefined;

  public updateRentPaymentFailureFeeSettings = async (payload: RentPaymentFailureFeeSettings): Promise<RentPaymentFailureFeeSettings> => {
    const url = `${BASE_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  };

  public async addRentPaymentFailureFeeSettingsByLevel(level: string, levelId: string, payload: RentPaymentFailureFeeSettings) {
    const url = BASE_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteRentPaymentFailureFeeSettingsByLevel(level: string, levelId: string) {
    const url = `${BASE_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }

  public async getAllRentPaymentFailureFeeSettings(): Promise<RentPaymentFailureFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${BASE_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }
}
